/**
 * PowerPoint operations.
 *
 * PowerPoint's strongly-typed JS API exposes limited shape access across
 * versions, so we use the Common API (`getSelectedDataAsync` /
 * `setSelectedDataAsync`), which is broadly supported:
 *  - read  -> currently selected text on the active slide
 *  - insert -> drops a text box with the supplied text on the active slide
 */

function asyncResult<T>(
  fn: (cb: (res: Office.AsyncResult<T>) => void) => void
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    fn((res) => {
      if (res.status === Office.AsyncResultStatus.Succeeded) {
        resolve(res.value)
      } else {
        reject(new Error(res.error?.message || 'PowerPoint operation failed'))
      }
    })
  })
}

export async function getSelectedSlideText(): Promise<string> {
  return asyncResult<string>((cb) =>
    Office.context.document.getSelectedDataAsync(Office.CoercionType.Text, cb)
  )
}

export async function insertTextBox(text: string): Promise<void> {
  await asyncResult<void>((cb) =>
    Office.context.document.setSelectedDataAsync(
      text,
      { coercionType: Office.CoercionType.Text },
      cb
    )
  )
}
